<template>
    <v-card>
        <v-card-title class="title">Відхилення позиції</v-card-title>
        <v-card-text>
            Ви впевнені, що хочете відхилити вибрану позицію?
            
            <v-textarea v-model="reason" 
                          solo
                          class="mt-2"
                          label="Причина відхилення позиції (для викладача)"
            ></v-textarea>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                    color="primary"
                    @click.native="$emit('shouldCloseRejectConfirm')"
                    :disabled="loadingDelete"
            >Ні
            </v-btn>
            <v-btn
                    color="primary"
                    text
                    @click.native="rejectItem"
                    :loading="loadingDelete"
                    :disabled="loadingDelete"
            >Так
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
    import HttpService from "../../../HttpService";

    export default {
        data: () => {
            return {
                loadingDelete: false,
                reason: "",
            };
        },
        props: {
            positionId: Number,
        },
        methods: {
            rejectItem() {
                this.loadingDelete = true;

                HttpService.getInstance()
                    .post(`ratingAdmin/rejectPosition/${this.positionId}`, {reason: this.reason})
                    .then(resp => {
                        this.loadingDelete = false;

                        this.$emit("rejected");
                    });
            }
        }
    }
</script>